import { useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Button, Divider } from 'semantic-ui-react';
import { getMomentsV2 } from '../actions/kioskActions';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import messages, { FormattedMessage } from 'shared/messages/messages';

const styles = () => ({
});

const AccessCodeMomentLookup = (props) => {
    const { visible, onClose } = props;
    const [accessCode, setAccessCode] = useState('');

    const handleSearchMoment = async () => {
        const { getMomentsV2, settings } = props;

        let today = new Date();
        let yesterday = new Date(today.setDate(today.getDate() - 1));
        let dateFilter = yesterday.toISOString().split('T')[0]

        let jobIds = settings.pre_print_job_ids;
        if (!jobIds.includes(settings.job_id)) {
            jobIds.push(settings.job_id);
        }

        // TODO: If query performance is poor, it may be worth looking into add "IN"
        // as a portal filter option since current "OR"s could be a problem
        let jobIdParams = jobIds.map((job_id) => {
            return { filterClass: 'number', filterType: 'equals', value: job_id.toString(), operator: 'OR' }
        });

        let page = 1;
        let perPage = 100;
        let sortModel = [{ sort: "desc", colId: "date" }];
        let filterModel = {
            preview: [{
                filterClass: 'date',
                filterType: 'greaterThan',
                value: dateFilter,
                operator: 'AND'
            }],
            job_id: jobIdParams,
            hidden: [{
                filterClass: 'number',
                filterType: 'notEqual',
                value: '1',
                operator: 'AND'
            }],
            _operator: [{
                operator: 'AND',
                value: 'AND',
                filterClass: "",
                'filterType': ""
            }],
            access_code: [{
                filterClass: 'text',
                filterType: 'equals',
                value: accessCode,
                operator: 'AND'
            }],
        }

        await getMomentsV2(page, perPage, filterModel, sortModel);
        onClose(false);
    }

    const dialogFooter = () => {
        return <div>
            <Divider />
            <Button.Group>
                <Button onClick={() => onClose(true)}><FormattedMessage {...messages.kiosk_print_size_edits_cancel} /></Button>
                <Button primary onClick={handleSearchMoment}><FormattedMessage {...messages.kiosk_print_size_edits_continue} /></Button>
            </Button.Group>
        </div>
    }


    return <Dialog header='Search Images' visible={visible}
        style={{ width: '40vw' }} onHide={() => onClose(true)} footer={dialogFooter}>
        <InputText placeholder='Enter Access Code' onChange={(e) => setAccessCode(e.target.value)} style={{ width: '100%' }} />
    </Dialog>
}

const mapStateToProps = state => ({
    settings: state.kioskReducer.settings,
    user: state.kioskReducer.user,
});

export default connect(mapStateToProps, { getMomentsV2 })(withStyles(styles)(AccessCodeMomentLookup));
